export interface IProps {
  text?: string;
  type?: CardType;
  icon?: string;
  href?: string;
}

export enum CardType {
  PDF_VIEWER = "preview pdf",
  REDIRECT = "redirect",
  CONTACT = "contact",
}
